/**
 * ExecutiveSummary — the narrative that opens every Marketing Strategy.
 *
 * Reads like advice from a marketing director, never like software
 * output. Deterministic; produced by ``PlannerService`` server-side.
 */
import { Card } from "@/shared/ui/card";

export function ExecutiveSummary({ summary }: { summary: string }): JSX.Element {
  // Split by blank line so we render each paragraph with its own spacing.
  const paragraphs = summary.split(/\n\s*\n/).filter((p) => p.trim());
  return (
    <section data-testid="strategy-executive-summary">
      <Card className="p-8 sm:p-10 border-l-4 border-l-primary">
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
          Executive Summary
        </p>
        {paragraphs.map((p, i) => (
          <p
            key={i}
            className="text-lg sm:text-xl leading-relaxed font-serif mb-4 last:mb-0"
          >
            {p}
          </p>
        ))}
      </Card>
    </section>
  );
}
